import {Component, Inject, OnInit, Renderer2} from '@angular/core';
import {DOCUMENT} from '@angular/common';
import {NavigationEnd, Router} from "@angular/router";
import {AuthService} from './home/auth/auth.service';
import {environment} from 'src/environments/environment';
import {APPTYPES} from './share/constants/common-constants';
import {filter, map} from "rxjs/operators";
import { SelectedOrgService } from './share/services/selected-org.service';
import { VersionCheckService } from './share/services/version-check.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  standalone: false
})
export class AppComponent implements OnInit {
  envType = environment?.envType || 'SDEX';
  appType = APPTYPES;

  constructor(private readonly renderer: Renderer2, private readonly router: Router, private readonly authService: AuthService,
    private readonly selectedOrgService: SelectedOrgService,
    @Inject(DOCUMENT) private readonly document: Document, private readonly versionCheckService: VersionCheckService) {
    const definedRouter = this.router;
    const definedSelectedOrgService = this.selectedOrgService;

    function LogoutApplication() {
      definedSelectedOrgService.clearAll();
      localStorage.clear();
      sessionStorage.clear();
      definedRouter.navigate(['login']);
    }

    if (!window.location.pathname.includes('public/document-vault')) {
      const bc = new BroadcastChannel("sdex-web-app");
      bc.onmessage = (event) => {
        if (event.data === 'logOut') {
          LogoutApplication();
        }
      };
    }
  }

  ngOnInit() {
    this.router.events.pipe(
      filter(event => event instanceof NavigationEnd),
      map(() => {
        let route = this.router.routerState.snapshot.root;
        while (route.firstChild) {
          route = route.firstChild;
        }
        return route.data['bodyClass'];
      })
    ).subscribe((bodyClass) => {
      window.scrollTo({top: 0, behavior: 'smooth'});
      if (bodyClass) {
        this.renderer.addClass(this.document.body, bodyClass);
      } else {
        this.document.body.className = '';
      }
    })
    this.versionCheckService.startPolling();
  }
}

